<template>
  <div>
    <div class="tw-my-4">
      <back-nav
        :to="
          $route.name === 'InstmentPayment'
            ? null
            : coverType.coverTypeId === 120
            ? 'ValuerSelection'
            : 'VehicleDetailsReview'
        "
      />
    </div>
    <v-card class="tw-mt-5 md:tw-mt-16 tw-py-1 md:tw-py-1">
      <card-title class="mx-10">Overview</card-title>
      <v-form v-model="isValid">
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
          <top-stepper current="BranchSelections" :cover-type="coverType" />
          <div>
            <div class="tw-w-full tw-mt-4 md:tw-mt-10">
              <h3
                class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8"
              >
                Select your ideal branch to handle your business
              </h3>
              <hr class="tw-mt-3 tw-mb-5" />
            </div>
            <v-radio-group
                v-if="!branchesLoading"
              v-model="branchCode1"
              :rules="[(v) => !!v || 'Pick up Location is required']"
            >
              <div
                class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-px-2 md:tw-px-8"
              >
                <v-radio
                  v-for="(branch, $index) in branches"
                  :key="$index"
                  :value="branch.code"
                  class="tw-px-2 md:tw-px-5 tw-mt-3 md:tw-mt-6"
                >
                  <template #label>
                    <ul class="list-none">
                      <li>{{ branch.name }}</li>
                      <li class="tw-mt-1">
                        <span class="c-blue-text">{{ branch.address }}</span>
                      </li>
                      <li>
                        Open:{{ branch.openingTime }} Close:{{
                          branch.closingTime
                        }}
                      </li>
                      <li>
                        <span class="c-blue-text">{{ branch.tel }}</span>
                      </li>
                    </ul>
                  </template>
                </v-radio>
              </div>
            </v-radio-group>
            <div v-else class="tw-w-full tw-flex tw-justify-center">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
          </div>
          <v-card-actions
            class="col-sm-6 offset-sm-3 tw-mt-5 md:tw-mt-8 tw-pb-8"
          >
            <v-btn
              block
              large
              color="secondary"
              class="my-3"
              :loading="loading"
              :disabled="
                !isValid || renewal.batchId === null || branchesLoading
              "
              @click="proceed"
            >
              Proceed To Payment
            </v-btn>
          </v-card-actions>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import BackNav from '@/components/buy/BackNav';
import axios from 'axios';
import { changeFormat, formatDate2, reverseFormat } from '@/utils/time';
import validations from '@/utils/validations';
import { FB_RENEW_SELECT_BRANCH } from '@/utils/const';
import TopStepper from '@/components/buy/TopStepper';
import renewalMixin from '@/mixins/renewalMixin';
import CardTitle from '@/components/shared/CardTitle';
import getCustomerId from '@/utils/getCustomerId';

export default {
  name: 'BranchSelectionReview',
  props: {
    renewal: {
      type: Object,
    },
  },
  components: {
    CardTitle,
    TopStepper,
    BackNav,
  },
  data() {
    return {
      loading: false,
      pageLoading: true,
      branchesLoading: true,
      branches: [],
      isValid: false,
      ...validations,
      branchCode1: '198',
      checked1: '',
      date: '',
      menu: false,
      time: null,
      menu2: false,
    };
  },
  mixins: [renewalMixin],
  computed: {
    computedDateFormatted() {
      return this.formatDate2(this.date);
    },
    quote() {
      return this.$store.getters['renewal/fetchQoute'];
    },
  },
  metaInfo: {
    title: 'Renew - Branch Selection',
  },
  mounted() {
    this.getBranches();
  },
  methods: {
    async proceed() {
      const customerId = getCustomerId();

      this.loading = true;
      const branch = this.branches.find(
        (e) => e.code === parseInt(this.branchCode1, 10),
      );
      const locationData = {
        policyNo: this.$route.params.policyNo,
        branchAddress: branch.address,
        branchClosingTime: branch.closingTime,
        branchCode: branch.code,
        branchLatitude: branch.latitude,
        branchLongitude: branch.longitude,
        branchName: branch.name,
        branchOpeningTime: branch.openingTime,
        branchShortDescription: branch.shortDescription,
        branchTel: branch.tel,
        pickupDate: this.computedDateFormatted,
        pickupLocation: branch.name,
        pickupTime: this.time,
        quoteId: this.quote.quoteId,
        customerId,
      };

      await axios
        .post('/motor/api/policy/sumbitBranch', locationData)
        .then(() => {
          this.$toast.success('Pick Up Location successfully set');
          this.loading = false;
          this.$analytics.logEvent(FB_RENEW_SELECT_BRANCH, {
            product: 'Renewal Journey Select Branch',
          });
          this.$emit('to-policy-review', this.renewal);
        });
    },
    changeFormat,
    formatDate2,
    reverseFormat,
    getBranches() {
      axios.post('/motor/api/branch/list').then((response) => {
        this.branches = response.data.data;
        this.branchesLoading = false;
      });
    },
    allowedDates: (val) => ![0, 6].includes(new Date(val).getDay()),
    allowedHours: (val) => ![0, 1, 2, 3, 4, 5, 6, 7, 18, 19, 20, 21, 22, 23, 24].includes(val),
  },
};
</script>
